import {
  FILES_PAGE,
  GENERAL_SETTINGS_PAGE,
  SETTINGS_PAGE_ROOT_PATH,
} from 'src/constants';

const matchesPath = (pathname: string, path: string) =>
  pathname === path || pathname.startsWith(`${path}/`);

export const isFilesNavItemSelected = (pathname: string) =>
  matchesPath(pathname, FILES_PAGE.path);

export const isGeneralSettingsNavItemSelected = (pathname: string) =>
  pathname === SETTINGS_PAGE_ROOT_PATH ||
  matchesPath(pathname, GENERAL_SETTINGS_PAGE.path);

interface SelectableNavItem {
  path: string;
  selected?: boolean;
  subItems?: SelectableNavItem[];
}

/**
 * Whether a nav item is the active route. An explicit boolean `selected` wins
 * over path matching so items can opt in/out when a sub-path owns the
 * highlight; otherwise the item is selected when its path prefixes the route.
 */
export const isNavItemSelected = (
  pathname: string,
  navItem: SelectableNavItem,
): boolean => {
  if (typeof navItem.selected === 'boolean') return navItem.selected;
  if (navItem.path === '/') return pathname === '/';
  return pathname.startsWith(navItem.path);
};

/**
 * A folder should stay open only while one of its children is the active item.
 * Matching the child's full selection logic (rather than just the first path
 * segment) keeps unrelated folders closed — e.g. vibe apps
 * (`/app-setup/build/session/...`) and App Setup (`/app-setup`) share the
 * `app-setup` segment, so segment matching opened every folder with a vibe app.
 */
export const isFolderOpenForPath = (
  pathname: string,
  item: SelectableNavItem,
): boolean =>
  Boolean(
    item.subItems?.some((subItem) => isNavItemSelected(pathname, subItem)),
  );
